module.exports = __webpack_public_path__ + "static/media/quality.27d86117.png";